import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '@deal/components'
import { RecommendedListSellableCardFragment } from '#src/generated/graphql'
import { getSellableUrl } from '#src/services/sellable'
import { formatMonetaryAmountAsJsx } from '#src/services/money'
import YachtCabins from '../yacht-cabins.svg'
import YachtCapacity from '../yacht-capacity.svg'
import styles from './styles.css'

interface SellableListProps {
  sellables: RecommendedListSellableCardFragment[]
}

const SellableList: React.SFC<SellableListProps> = ({ sellables }) => {
  return (
    <div className={styles.sellables}>
      {sellables.slice(0, 2).map(sellable => {
        if (sellable.images.length === 0) {
          return null
        }

        const sellableImage = sellable.images[0]

        return (
          <div className={styles.sellable} key={sellable.id}>
            <div className={styles.image}>
              <div className={styles.gradientMask} />
              <div className={styles.details}>
                {sellable.serviceLocation && sellable.serviceLocation.displayTitle && (
                  <div className={styles.location}>{sellable.serviceLocation.displayTitle}</div>
                )}
                <div className={styles.title}>
                  <Link to={getSellableUrl(sellable)} className={styles.titleLink}>
                    {sellable.title}
                  </Link>
                </div>
              </div>

              <Link to={getSellableUrl(sellable)}>
                <Image
                  src={sellableImage.url}
                  width={350}
                  height={200}
                  imgixParams={{
                    fit: 'crop'
                  }}
                  className={styles.sellableImage}
                />
              </Link>
            </div>

            <div className={styles.specs}>
              <div className={styles.amenities}>
                {sellable.charterCabins && sellable.charterCabins.formatted && (
                  <div className={styles.amenity}>
                    <YachtCabins />{' '}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: sellable.charterCabins.formatted.displayHtml
                      }}
                    />
                  </div>
                )}

                {sellable.charterCapacity && sellable.charterCapacity.formatted && (
                  <div className={styles.amenity}>
                    <YachtCapacity />{' '}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: sellable.charterCapacity.formatted.displayHtml
                      }}
                    />
                  </div>
                )}
              </div>
              {sellable.variationMatrix && sellable.variationMatrix.priceRange && (
                <div className={styles.price}>
                  From{' '}
                  <strong>
                    {formatMonetaryAmountAsJsx(sellable.variationMatrix.priceRange!.min, {
                      round: 'floor'
                    })}
                  </strong>
                </div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default SellableList
